import { useTranslation } from 'react-i18next';
import NoDevice from './NoDevice';
import ErrorTitle from './ErrorTitle';

const NoSpeakerError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle
        title={t('We could not detect any {{device}}', {
          device: t('speaker'),
        })}
      />
      <NoDevice device="speaker" />
    </>
  );
};

export { NoSpeakerError };
